const UnauthorizedAccess = ({  }) => {

  return (
    <div className="unlock-section h-100 d-flex flex-column align-items-center justify-content-center text-center">
      <h1>Unauthorized</h1>
      <p>You are not allowed to view this page.</p>
    </div>
  )
}

export default UnauthorizedAccess;